import styled from "@emotion/styled";

export const BodyLoading = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 2147483647;
  font-family: ${props => props.theme.fontRoboto};
  background: ${props => props.theme.palette.background.default};
  @keyframes rotate-animation {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ContainerLoading = styled.div`
  padding: 32px;
  height: 100%;
  height: -moz-available;
  height: -webkit-fill-available;
  height: fill-available;
  text-align: center;
  .title{
    font-weight: 400;
    margin-top: 11.8px;
    color: ${props => props.theme.palette.text.secondary};
    font-family: 'Roboto';
  }
  
  .hide {
    opacity: 0;
  }

  img {
    animation: rotate-animation 1s infinite linear;
  }

  .show-in {
    animation: fadeIn 500ms cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
    animation-delay: 500ms;
  }

  .show-out {
    animation: fadeOut 500ms cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    70% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

`;

export const ColorLayerAbove = styled.div`
  position: absolute;
  height: 0px;
  width: 100vw;
  bottom: 0;
  left: 0;
  transition: all ${props => props.animation.speed}ms ease-in;
  z-index: -1;

`;

export const WrapperMessageContent = styled.div`
  position: absolute;
  bottom: 50%;
  left: 0;
  width: 100%;
  z-index: 2147483647;
  
  img {
    -khtml-user-select: none;
    -o-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }
`;
